import { useState } from 'react';
import { AppointmentStatusTag } from 'src/pages/_components/AppointmentStatusTag/AppointmentStatusTag';
import { Appointment, AppointmentStatus } from '../../../../gql/graphql';
import styles from './AppointmentCardCompact.module.scss';
import { Tag } from '../../../../ui/components/Tag/Tag';
import { secondsToText, timeToSec } from '../../../../ui/utils/time';
import { getAge } from '../../../../ui/utils/age';
import { CancelAppointmentModal } from './components/CancelAppointmentModal/CancelAppointmentModal';
import { ViewMoreAppointmentDetailsModal } from './components/ViewMoreAppointmentDetailsModal/ViewMoreAppointmentDetailsModal';
import {
  ButtonWithMenu,
  ButtonWithMenuItem,
} from '../../../../ui/components/ButtonWithMenu/ButtonWithMenu';
import { MoveAppointmentModal } from './components/MoveAppointmentModal/MoveAppointmentModal';
import { StartAppointmentModal } from './components/StartAppointmentModal/StartAppointmentModal';
import { CompleteAppointmentModal } from './components/CompleteAppointmentModal/CompleteAppointmentModal';
import { BadStatusAppointmentModal } from './components/BadStatusAppointmentModal/BadStatusAppointmentModal';

const statusesAllowedToCancel: string[] = [
  AppointmentStatus.Created,
  AppointmentStatus.Pending,
  AppointmentStatus.OnHold,
  AppointmentStatus.Rescheduled,
  AppointmentStatus.Confirmed,
];

const statusesAllowedToStart: string[] = [
  AppointmentStatus.Created,
  AppointmentStatus.Pending,
  AppointmentStatus.OnHold,
  AppointmentStatus.Rescheduled,
  AppointmentStatus.Confirmed,
  AppointmentStatus.Late,
];

const statusesAllowedToComplete: string[] = [AppointmentStatus.InProgress];
export const AppointmentCardCompact = (appointment: Appointment) => {
  const { hourOfAppointment, Client, status, service } = appointment;
  const [cancelModalIsOpen, setCancelModalIsOpen] = useState(false);
  const [moveAppointmentModalIsOpen, setMoveAppointmentModalIsOpen] =
    useState(false);
  const [startAppointmentModalIsOpen, setStartAppointmentModalIsOpen] =
    useState(false);
  const [completeAppointmentModal, setCompleteAppointmentModal] =
    useState(false);
  const [viewMoreModal, setViewMoreModal] = useState(false);
  const [badStatusModalIsOpen, setBadStatusModalIsOpen] = useState(false);
  const menuItems: ButtonWithMenuItem[] = [
    {
      text: 'Ver detalles',
      onClick: () => {
        setViewMoreModal(true);
      },
      icon: 'eye',
    },
    {
      text: 'Iniciar cita',
      onClick: () => {
        setStartAppointmentModalIsOpen(true);
      },
      icon: 'play',
      visible: statusesAllowedToStart.includes(status),
    },
    {
      text: 'Resolver cita', // implementar
      onClick: () => {
        setCompleteAppointmentModal(true);
      },
      icon: 'hourglass',
      visible: status === AppointmentStatus.Unfinished,
    },
    {
      text: 'Mover cita',
      onClick: () => setMoveAppointmentModalIsOpen(true),
      icon: 'clock',
      visible: statusesAllowedToCancel.includes(status),
    },
    {
      text: 'Completar cita',
      onClick: () => setCompleteAppointmentModal(true),
      icon: 'clock',
      visible: statusesAllowedToComplete.includes(status),
    },
    {
      text: 'Cancelar',
      onClick: () => setCancelModalIsOpen(true),
      icon: 'warning',
      visible: statusesAllowedToCancel.includes(status),
    },
    {
      text: 'Estado incorrecto', // implementar
      onClick: () => setBadStatusModalIsOpen(true),
      icon: 'state-error',
      visible: AppointmentStatus.Expired === status,
    },
  ];

  return (
    <div className={styles.root}>
      <div className={styles.information}>
        <Tag
          icon="clock"
          iconColor="secondary"
          text={`${hourOfAppointment} - ${secondsToText(
            timeToSec(hourOfAppointment) + Number(service?.durationInSec)
          )}`}
        />
        <div className={styles['client-name']}>
          {`${Client.name} ${Client.lastName} de ${getAge(
            new Date(Client.birthday)
          )} años`}
        </div>
      </div>
      <div className={styles['right-side']}>
        <AppointmentStatusTag status={status} />
        <ButtonWithMenu className={styles.menu} items={menuItems} />
      </div>
      <CancelAppointmentModal
        setIsOpen={setCancelModalIsOpen}
        isOpen={cancelModalIsOpen}
        appointment={appointment}
      />
      <ViewMoreAppointmentDetailsModal
        isOpen={viewMoreModal}
        setIsOpen={setViewMoreModal}
        appointment={appointment}
      />
      {moveAppointmentModalIsOpen && (
        <MoveAppointmentModal
          isOpen={moveAppointmentModalIsOpen}
          setIsOpen={setMoveAppointmentModalIsOpen}
          appointment={appointment}
        />
      )}
      <StartAppointmentModal
        isOpen={startAppointmentModalIsOpen}
        setIsOpen={setStartAppointmentModalIsOpen}
        appointment={appointment}
      />
      <CompleteAppointmentModal
        isOpen={completeAppointmentModal}
        setIsOpen={setCompleteAppointmentModal}
        appointment={appointment}
      />
      <BadStatusAppointmentModal
        isOpen={badStatusModalIsOpen}
        setIsOpen={setBadStatusModalIsOpen}
        appointment={appointment}
        onStatusChange={(s) => {
          switch (s) {
            case AppointmentStatus.Completed:
              setCompleteAppointmentModal(true);
              break;
            case AppointmentStatus.Canceled:
              setCancelModalIsOpen(true);
              break;
            default:
              console.warn('Unhandled status change:', status);
              break;
          }
        }}
      />
    </div>
  );
};
